import React from "react";
import { cn } from "@/lib/utils";
import { SuiteLauncher } from "./SuiteLauncher";

/**
 * Menu principale verticale del Gestionale di Studio.
 * La barra è sempre aperta e ha larghezza fissa, senza modalità compatta.
 */
export function SuiteSidebar({
  items = [],
  activeValue,
  onSelect,
  className,
  testid = "suite-sidebar",
}) {
  return (
    <nav
      className={cn("suite-sidebar-v2 flex flex-col shrink-0", className)}
      data-collapsed="false"
      data-testid={testid}
      style={{
        width: 224,
        backgroundColor: "#FFFFFF",
        borderRight: "1px solid #E5E7EB",
      }}
      aria-label="Menu principale"
    >
      <div className="shrink-0" style={{ padding: "10px 12px 8px" }}>
        <SuiteLauncher collapsed={false} />
      </div>

      <div className="flex-1 overflow-y-auto" style={{ padding: "8px 0" }}>
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = activeValue === item.value;
          return (
            <button
              key={item.value}
              type="button"
              onClick={() => onSelect?.(item.value)}
              title={item.label}
              data-active={isActive ? "true" : "false"}
              data-testid={item.testid || `sidebar-nav-${item.value}`}
              className="suite-sidebar-v2-item"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                width: "calc(100% - 12px)",
                margin: "1px 6px",
                padding: "0 12px",
                height: 40,
                borderRadius: 8,
                border: "none",
                backgroundColor: isActive ? "rgba(11,107,79,0.08)" : "transparent",
                color: isActive ? "var(--gis-green)" : "#1F2A24",
                fontSize: 13.5,
                fontWeight: isActive ? 600 : 500,
                cursor: "pointer",
                position: "relative",
                justifyContent: "flex-start",
                fontFamily: "var(--gis-font-heading)",
                textAlign: "left",
                letterSpacing: "-0.005em",
                transition: "background-color 120ms ease, color 120ms ease",
              }}
              onMouseEnter={(event) => {
                if (!isActive) {
                  event.currentTarget.style.backgroundColor = "rgba(11,107,79,0.05)";
                  event.currentTarget.style.color = "var(--gis-green)";
                }
              }}
              onMouseLeave={(event) => {
                if (!isActive) {
                  event.currentTarget.style.backgroundColor = "transparent";
                  event.currentTarget.style.color = "#1F2A24";
                }
              }}
            >
              {isActive && (
                <span
                  aria-hidden
                  style={{
                    position: "absolute",
                    left: -6,
                    top: 6,
                    bottom: 6,
                    width: 3,
                    borderRadius: "0 2px 2px 0",
                    backgroundColor: "var(--gis-green)",
                  }}
                />
              )}
              {Icon && <Icon size={18} strokeWidth={1.75} />}
              <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default SuiteSidebar;
